// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"228":"2ca1d895bc51b323","537":"97d59616ff0b132d"}[chunkId] + ".js";
};